import { api } from "./api";

export interface AnonymousCreatePayload {
  anonymousName: string;
  anonymousPassword: string;
}

export interface AnonymousUpdatePayload {
  anonymousPassword: string;
}

export type SlideQCResult = 'PASS' | 'FAIL' | 'ERROR' | 'SKIPPED';

export interface Slide {
  slideId: number;
  slidename: string;
  filename: string;
  caption: string;
  gender: string;
  age: string;
  site: string;
  zindanName: string;
  thumbnail: string;
  annotations: Annotation[];
  slideComments: any[];
  description?: string;
  groupId?: string | null;
  qcResult?: SlideQCResult | null;
}

export interface Annotation {
  annoId: number;
  slideId: number;
  annoInfo: string;
  content: string;
  writer: string;
  anonymous?: boolean; // 익명 사용자 처리용
}

export interface slideOrderType {
  slideId: number;
  listOrder: number;
}

export const getSlideData = async (slideId: number) => {
  try {
    const { data } = await api().get(
      `/slide/${slideId}/annotations-slidecomments`
    );
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};
 
export const getPhotoData = async (photoId: number) => {
  try {
    const { data } = await api().get(
      `/annotation-photo/${photoId}`
    );
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getGrossAnnotationList = async (grossPhotoId: number) => {
  try {
    const { data } = await api().get(
      `/annotation-gross-photo/${grossPhotoId}`
    );
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const patchSlideData = async (slideData: any) => {
  try {
    const { data } = await api().patch("/slide/update", slideData);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const saveSlideQCResult = async (slideId: number, qcResult: SlideQCResult) => {
  try {
    const { data } = await api().patch('/slide/qc-result', { slideId, qcResult });
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteSlide = async (slideId: number) => {
  try {
    const { data } = await api().delete(`/slide/${slideId}`);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const deleteSlideList = async (slideIds: number[]) => {
  try {
    const { data } = await api().delete("/slide/list", { data: slideIds });
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postAnnotation = async (
  slideId: number,
  annoInfo: string,
  content: string,
  anonymous?: AnonymousCreatePayload
) => {
  try {
    const body = anonymous
      ? { slideId, annoInfo, content, ...anonymous }
      : { slideId, annoInfo, content };
    const { data } = await api().post("/annotation", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postImageAnnotation = async (
  photoId: number,
  annoInfo: string,
  content: string
) => {
  try {
    const body = { photoId, annoInfo, content };
    const { data } = await api().post("/annotation-photo", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postGrossAnnotation = async (
  grossPhotoId: number,
  annoInfo: string,
  content: string
) => {
  try {
    const body = { grossPhotoId, annoInfo, content };
    const { data } = await api().post("/annotation-gross-photo", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const patchAnnotation = async (
  annotationId: number,
  annoInfo: object,
  content: string,
  anonymous?: AnonymousUpdatePayload
) => {
  try {
    const body = anonymous
      ? { id: annotationId, annoInfo, content, ...anonymous }
      : { id: annotationId, annoInfo, content };
    console.log(body);
    const { data } = await api().patch("/annotation", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const updateImageAnnotation = async (
  annotationId: number,
  annoInfo: object,
  content: string
) => {
  try {
    const body = { antnPhotoId: annotationId, annoInfo, content };
    console.log(body);
    const { data } = await api().post("/annotation-photo/update", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const updateGrossAnnotation = async (
  annotationId: number,
  annoInfo: object,
  content: string
) => {
  try {
    const body = { antnGrossPhotoId: annotationId, annoInfo, content };
    console.log(body);
    const { data } = await api().post("/annotation-gross-photo/update", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const deleteAnnotation = async (
  annotationId: number,
  anonymousPassword?: string
) => {
  try {
    const response = await api().delete(`/annotation/${annotationId}`, {
      params: anonymousPassword ? { password: anonymousPassword } : undefined,
    });
    return response.status >= 200 && response.status < 300;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteImageAnnotation = async (annotationId: number) => {
  try {
    const response = await api().delete(`/annotation-photo/${annotationId}`);
    return response.status >= 200 && response.status < 300;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteGrossAnnotation = async (antnGrossPhotoId: number) => {
  try {
    const body = { antnGrossPhotoId };
    const response = await api().post("/annotation-gross-photo/delete", body);
    return response.status >= 200 && response.status < 300;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const postComment = async (
  slideId: number,
  content: string,
  anonymous?: AnonymousCreatePayload
) => {
  try {
    const body = anonymous
      ? { slideId, content, ...anonymous }
      : { slideId, content };
    const { data } = await api().post("/slideComment", body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const putComment = async (
  scId: number,
  content: string,
  anonymous?: AnonymousUpdatePayload
) => {
  try {
    const body = anonymous
      ? { scId, content, ...anonymous }
      : { scId, content };
    const { data } = await api().put("/slideComment", body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const putSlideOrderByList = async (slideList: slideOrderType[]) => {
  try {
    const body = slideList;
    const { data } = await api().put("/slide/listOrder/list", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteComment = async (
  commentId: number,
  anonymousPassword?: string
) => {
  try {
    const response = await api().delete(`/slideComment/${commentId}`, {
      params: anonymousPassword ? { password: anonymousPassword } : undefined,
    });
    return response.status >= 200 && response.status < 300;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const downloadSlide = async (slideId: number) => {
  try {
    const body = { slideId };
    const { data } = await api().post("/slide/download", body, {
      responseType: "blob",
    });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getSlideInfo = async (slideId: number) => {
  try {
    const { data } = await api().get(`/slideInfo/${slideId}`);
    return data.data;
  } catch (e) {
    console.error(e);
    throw new Error("정보를 불러오는데 실패했습니다.");
  }
};

export const addSlideInfo = async (slideId: number, pathologyNumber: string, memo: string) => {
  try {
    const body = { slideId, pathologyNumber, memo };
    const { data } = await api().post("/slideInfo/save", body);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error("정보를 추가하는데 실패했습니다.");
  }
};

export const updateSlideInfo = async (infoId: number, pathologyNumber: string, memo: string) => {
  try {
    const body = { infoId, pathologyNumber, memo };
    const { data } = await api().post("/slideInfo/update", body);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error("정보를 수정하는데 실패했습니다.");
  }
};

/**
 * @deprecated 구 슬라이드 전용 그룹 API. 화면에서는 더 이상 쓰지 않는다.
 *   신규 그룹은 api/mediaGroupAPI.ts 의 /api/media-groups 를 사용할 것.
 *   BE DB 마이그레이션 때 이 두 함수와 slide.groupId(문자열)를 함께 제거한다.
 */
export const updateSlideGroup = async (slideId: number, groupId: string | null) => {
  try {
    const { data } = await api().post("/slide/group", { slideId, groupId });
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/** @deprecated updateSlideGroup 과 동일 — /api/media-groups 의 getMediaGroups 를 사용할 것 */
export const getSlideGroupsByPost = async (postId: number) => {
  try {
    const { data } = await api().get(`/post/${postId}/slide-groups`);
    return data.data as { groupId: string; slideCount: number }[];
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const deleteSlideInfo = async (infoId: number) => {
  try {
    const body = { infoId };
    const { data } = await api().post("/slideInfo/delete", body);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error("정보를 삭제하는데 실패했습니다.");
  }
};
